import httpClient from "@/_shared/http-client";

export const usePagination = {
  data() {
    return {
      pagesCounter: 1,
      currentPage: 1,
    };
  },
  methods: {
    async changePage(value, withoutSearchCallback) {
      if (!this.searchingParams) {
        return await this[withoutSearchCallback](value);
      }
      this.isLoadingNow = true;
      const currentParams = `${this.searchingParams}&page=${value}`;
      const url = `/records/${this.tableName}?${currentParams}`;
      await httpClient
        .get(url)
        .then((res) => {
          this.filteredRecords = res.data.records;
          this.usePagination(value, this.pagesCounter);
        })
        .finally(() => {
          this.isLoadingNow = false;
        });
    },
    usePagination(page = 1, pagesCounter, withScroll = true) {
      this.pagesCounter = pagesCounter;
      this.currentPage = page;
      if (withScroll) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/usePagination.js